<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Dispute</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <create-dispute-form></create-dispute-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CreateDisputeForm from "@/components/Kleyton/Forms/Dispute/CreateDisputeForm";

export default {
  name: "CreateDispute",
  page: {
    title: "Create Dispute",
    meta: [{ name: "Create Disputes", content: window.__env.app.description }]
  },

  components: {
    CreateDisputeForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "Dispute",
      title: "Create Dispute",
      items: [
        {
          text: "Dispute",
          href: "/"
        },
        {
          text: "Create Dispute",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
